<template>
    <div class="mine-content">
        <div class="mine-header"><span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png"/></span>About Company</div>
        <div class="second-pard" v-if="!!about_company" v-html="about_company"></div>
        <van-loading
        v-show="showloding"
        size="50px"
        color="#1989fa"
        vertical/>
    </div>
    </template>
    <script>
    import Vue from "vue";
    import { Loading } from "vant";
    Vue.use(Loading);
    export default {
      data() {
        return {
          about_company:"",
          showloding: true,
        };
      },
      methods:{
        findConfig() {
        this.showloding = true;
          this.axios.get(this.api.api_findOneConfigByKeyName, {
              params: {key_name: "about_company"}
            })
            .then((res) => {
              this.showloding = false;
              if (res.data.code == 0) {
                this.about_company = res.data.data.key_value;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      },
      created(){
        this.findConfig();
      }
    };
    </script>
    <style lang="scss" scoped>
    .mine-content{
      font-size: 0.32rem;
      background: rgb(235, 235, 235);
      color:rgb(103, 103, 103);
      width: 100%;
      height: 100%;
      .mine-header{
        color: black;
        font-weight: bold;
        height: 1rem;
        display: grid;
        grid-template-columns: 30% 1fr 30%;
        align-items: center;
        text-align: center;
        .back{
          cursor: pointer;
          img {
            display: block;
            margin-left: 5%;
            width: 0.5rem;
            transform: rotate(180deg);
          }
        }
      }
      .second-pard{
        font-size: 0.34rem;
        width: 96%;
        background: white;
        margin: auto;
        padding: 10px 10px;
        border-radius: 10px/10px;
      }
    }
    </style>  